module.exports = __webpack_public_path__ + "static/img/track_en_yellow.ead95730.png";